function SubscribeForm() {
  // TODO: Waiting on emailjs to change this method
  // function sendEmail() {
  // const from_email = document.getElementById("email").value;
  // window.Email.send({
  //   SecureToken: "0b8252ae-8d89-4ee3-8e81-2d9179c4fd84",
  //   To: process.env.REACT_APP_BONEHEADS_EMAIL,
  //   From: from_email,
  //   Subject: "Subscribe email",
  //   Body: from_email + " would like to subscribe"
  // }).then(
  //   message => alert(message)
  // );
  // alert("Subscription service is currently under construction");
  // }

  return (
    <div
      className="col-md-12"
      style={{ textAlign: "center", marginTop: "40px", marginBottom: "30px" }}
      key={Math.random()}
    >
      <iframe
        title="laylo"
        id="laylo-drop-RH4bE"
        frameBorder="0"
        scrolling="no"
        allow="web-share"
        allowtransparency="true"
        style={{
          width: "100%",
          maxWidth: "700px",
          height: "176px",
        }}
        src={`https://embed.laylo.com?dropId=RH4bE&color=a0a0a0&minimal=false&theme=dark&force_reload=${Math.random()}`}
      ></iframe>
    </div>
  );
}

export default SubscribeForm;
